import { environment } from '../../environment';

// Root
export const PATH_HOME = '/';

// Errors
export const PATH_NOT_FOUND = '/ressource-introuvable';

// Health
export const PATH_HEALTH_CHECK = environment.healthEndpoint;

// Login, logout, etc
export const PATH_LOGIN = '/connexion';

//==========================================================================
// Admin
//==========================================================================

export const PATH_REFERENCES = '/referentiel';
export const PATH_WORKFLOWS = '/workflows';
export const PATH_DATA = '/donnees';
export const PATH_LOCALITY_INFOS = '/info-communes';

//==========================================================================
// GIS
//==========================================================================

const GIS_BASE = '/sig';
const GIS_FEATURE_DETAILS_BASE = `${GIS_BASE}/infos-element`;

export const PATH_GIS = GIS_BASE;
export const PATH_GIS_DEFAULT = PATH_GIS;
export const PATH_GIS_MAP_SETTINGS = `${GIS_BASE}/reglages-carte`;
export const PATH_GIS_FEATURE_DETAILS_CALCULATION_ASSUMPTIONS = `${GIS_FEATURE_DETAILS_BASE}/notes-hypotheses`;
export const PATH_GIS_FEATURE_DETAILS_DISTANCES = `${GIS_FEATURE_DETAILS_BASE}/distances`;
export const PATH_GIS_FEATURE_DETAILS_FOLDER_BUSINESS_ENTITY = `${GIS_FEATURE_DETAILS_BASE}/entite-dossier`;
export const PATH_GIS_FEATURE_DETAILS_THIRD_PARTY = `${GIS_FEATURE_DETAILS_BASE}/tiers`;
export const PATH_GIS_FEATURE_DETAILS_GEOCODING = `${GIS_FEATURE_DETAILS_BASE}/geocodage`;
export const PATH_GIS_FEATURE_DETAILS_DEFAULT =
  PATH_GIS_FEATURE_DETAILS_GEOCODING;
export const PATH_GIS_FEATURE_DETAILS_NATURAL_DISASTERS = `${GIS_FEATURE_DETAILS_BASE}/catastrophes-naturelles`;
export const PATH_GIS_FEATURE_DETAILS_OFFICIAL_JOURNAL = `${GIS_FEATURE_DETAILS_BASE}/journal-officiel`;

//==========================================================================
// Third parties, organizations, people (Internal & External)
//==========================================================================

export const PATH_EXTERNAL_ORGANIZATIONS = '/tiers/organisations';
export const PATH_EXTERNAL_THIRD_PARTIES_DEFAULT = PATH_EXTERNAL_ORGANIZATIONS;
export const PATH_EXTERNAL_THIRD_PARTIES_DISABLED = '/tiers/inactifs';
export const PATH_EXTERNAL_PEOPLE = '/tiers/personnes';
export const PATH_EXTERNAL_PEOPLE_NEW = '/tiers/personnes/nouvelle';
export const PATH_EXTERNAL_ORGANIZATIONS_NEW = '/tiers/organisations/nouvelle';
export const PATH_EXTERNAL_ORGANIZATIONS_SEARCH =
  '/tiers/organisations/recherche';

export const PATH_INTERNAL_ORGANIZATIONS = '/socna/societes';
export const PATH_INTERNAL_THIRD_PARTIES_DEFAULT = PATH_INTERNAL_ORGANIZATIONS;
export const PATH_INTERNAL_THIRD_PARTIES_DISABLED = '/socna/inactifs';
export const PATH_INTERNAL_PEOPLE = '/socna/personnes';
export const PATH_INTERNAL_PEOPLE_NEW = '/socna/personnes/nouvelle';
export const PATH_INTERNAL_ORGANIZATIONS_NEW = '/socna/societes/nouvelle';

const PERSON_BASE = '/personne/:id';

export const PATH_PERSON_GENERAL = `${PERSON_BASE}/infos-generales`;
export const PATH_PERSON_GENERAL_EDIT = `${PERSON_BASE}/infos-generales/edition`;
export const PATH_PERSON_DEFAULT = PATH_PERSON_GENERAL;
export const PATH_PERSON_CONTACT = `${PERSON_BASE}/contact`;
export const PATH_PERSON_CONTACT_EDIT = `${PERSON_BASE}/contact/edition`;
export const PATH_PERSON_ADDRESSES = `${PERSON_BASE}/adresses`;
export const PATH_PERSON_ADDRESSES_EDIT = `${PERSON_BASE}/adresses/edition`;
export const PATH_PERSON_ADDRESSES_EDIT_NEW = `${PERSON_BASE}/adresses/edition/nouvelle`;
export const PATH_PERSON_ADDRESSES_EDIT_MODIFY = `${PERSON_BASE}/adresses/edition/:addressId/modifier`;
export const PATH_PERSON_ADDRESSES_EDIT_DELETE = `${PERSON_BASE}/adresses/edition/:addressId/supprimer`;
export const PATH_PERSON_BILLING = `${PERSON_BASE}/facturation`;
export const PATH_PERSON_BILLING_EDIT = `${PERSON_BASE}/facturation/edition`;
export const PATH_PERSON_BANK = `${PERSON_BASE}/banque`;
export const PATH_PERSON_BANK_EDIT = `${PERSON_BASE}/banque/edition`;
export const PATH_PERSON_MEMBERSHIPS = `${PERSON_BASE}/organisations`;
export const PATH_PERSON_MEMBERSHIPS_EDIT = `${PERSON_BASE}/organisations/edition`;
export const PATH_PERSON_VERSIONS = `${PERSON_BASE}/versions`;
export const PATH_PERSON_ADMIN = `${PERSON_BASE}/administration`;
export const PATH_PERSON_ADMIN_EDIT = `${PERSON_BASE}/administration/edition`;
export const PATH_PERSON_PARTICIPATIONS = `${PERSON_BASE}/missions`;
export const PATH_PERSON_PENNYLANE = `${PERSON_BASE}/pennylane`;

const ORGANIZATION_BASE = '/organisation/:id';

export const PATH_ORGANIZATION_GENERAL = `${ORGANIZATION_BASE}/infos-generales`;
export const PATH_ORGANIZATION_GENERAL_EDIT = `${ORGANIZATION_BASE}/infos-generales/edition`;
export const PATH_ORGANIZATION_DEFAULT = PATH_ORGANIZATION_GENERAL;
export const PATH_ORGANIZATION_CONTACT = `${ORGANIZATION_BASE}/contact`;
export const PATH_ORGANIZATION_CONTACT_EDIT = `${ORGANIZATION_BASE}/contact/edition`;
export const PATH_ORGANIZATION_ADDRESSES = `${ORGANIZATION_BASE}/adresses`;
export const PATH_ORGANIZATION_ADDRESSES_EDIT = `${ORGANIZATION_BASE}/adresses/edition`;
export const PATH_ORGANIZATION_ADDRESSES_EDIT_NEW = `${ORGANIZATION_BASE}/adresses/edition/nouvelle`;
export const PATH_ORGANIZATION_ADDRESSES_EDIT_MODIFY = `${ORGANIZATION_BASE}/adresses/edition/:addressId/modifier`;
export const PATH_ORGANIZATION_ADDRESSES_EDIT_DELETE = `${ORGANIZATION_BASE}/adresses/edition/:addressId/supprimer`;
export const PATH_ORGANIZATION_BILLING = `${ORGANIZATION_BASE}/facturation`;
export const PATH_ORGANIZATION_BILLING_EDIT = `${ORGANIZATION_BASE}/facturation/edition`;
export const PATH_ORGANIZATION_RELATIONS = `${ORGANIZATION_BASE}/relations`;
export const PATH_ORGANIZATION_RELATIONS_EDIT = `${ORGANIZATION_BASE}/relations/edition`;
export const PATH_ORGANIZATION_BANK = `${ORGANIZATION_BASE}/banque`;
export const PATH_ORGANIZATION_BANK_EDIT = `${ORGANIZATION_BASE}/banque/edition`;
export const PATH_ORGANIZATION_MEMBERSHIPS = `${ORGANIZATION_BASE}/membres`;
export const PATH_ORGANIZATION_MEMBERSHIPS_EDIT = `${ORGANIZATION_BASE}/membres/edition`;
export const PATH_ORGANIZATION_DIRECTORY = `${ORGANIZATION_BASE}/annuaire`;
export const PATH_ORGANIZATION_VERSIONS = `${ORGANIZATION_BASE}/versions`;
export const PATH_ORGANIZATION_ADMIN = `${ORGANIZATION_BASE}/administration`;
export const PATH_ORGANIZATION_ADMIN_EDIT = `${ORGANIZATION_BASE}/administration/edition`;
export const PATH_ORGANIZATION_PARTICIPATIONS = `${ORGANIZATION_BASE}/missions`;
export const PATH_ORGANIZATION_PENNYLANE = `${ORGANIZATION_BASE}/pennylane`;

//==========================================================================
// Users
//==========================================================================

export const PATH_USERS_INTERNAL = '/utilisateurs/internes';
export const PATH_USERS_DEFAULT = PATH_USERS_INTERNAL;
export const PATH_USERS_EXTERNAL = '/utilisateurs/externes';
export const PATH_USERS_DISABLED = '/utilisateurs/inactifs';
export const PATH_USERS_NEW_INTERNAL = '/utilisateurs/nouveau/interne';
export const PATH_USERS_NEW_EXTERNAL = '/utilisateurs/nouveau/externe';

const USER_BASE = '/utilisateur/:id';
const USER_PERSON_BASE = `${USER_BASE}/personne`;

export const PATH_USER_USER_ACCOUNT = `${USER_BASE}/compte`;
export const PATH_USER_USER_DEFAULT = PATH_USER_USER_ACCOUNT;
export const PATH_USER_DEFAULT = PATH_USER_USER_DEFAULT;
export const PATH_USER_USER_AUTHORIZATIONS = `${USER_BASE}/autorisations`;
export const PATH_USER_USER_AUTHORIZATIONS_EDIT = `${USER_BASE}/autorisations/edition`;
export const PATH_USER_USER_SETTINGS = `${USER_BASE}/reglages`;
export const PATH_USER_USER_ADMIN = `${USER_BASE}/administration`;
export const PATH_USER_USER_ADMIN_EDIT = `${USER_BASE}/administration/edition`;

export const PATH_USER_PERSON_GENERAL = `${USER_PERSON_BASE}/infos-generales`;
export const PATH_USER_PERSON_GENERAL_EDIT = `${USER_PERSON_BASE}/infos-generales/edition`;
export const PATH_USER_PERSON_DEFAULT = PATH_USER_PERSON_GENERAL;
export const PATH_USER_PERSON_ADMIN = `${USER_PERSON_BASE}/administration`;
export const PATH_USER_PERSON_ADMIN_EDIT = `${USER_PERSON_BASE}/administration/edition`;
export const PATH_USER_PERSON_ADDRESSES = `${USER_PERSON_BASE}/adresses`;
export const PATH_USER_PERSON_ADDRESSES_EDIT = `${USER_PERSON_BASE}/adresses/edition`;
export const PATH_USER_PERSON_ADDRESSES_EDIT_NEW = `${USER_PERSON_BASE}/adresses/edition/nouvelle`;
export const PATH_USER_PERSON_ADDRESSES_EDIT_MODIFY = `${USER_PERSON_BASE}/adresses/edition/:addressId/modifier`;
export const PATH_USER_PERSON_ADDRESSES_EDIT_DELETE = `${USER_PERSON_BASE}/adresses/edition/:addressId/supprimer`;
export const PATH_USER_PERSON_BANK = `${USER_PERSON_BASE}/banque`;
export const PATH_USER_PERSON_BANK_EDIT = `${USER_PERSON_BASE}/banque/edition`;
export const PATH_USER_PERSON_BILLING = `${USER_PERSON_BASE}/facturation`;
export const PATH_USER_PERSON_BILLING_EDIT = `${USER_PERSON_BASE}/facturation/edition`;
export const PATH_USER_PERSON_MEMBERSHIPS = `${USER_PERSON_BASE}/organisations`;
export const PATH_USER_PERSON_MEMBERSHIPS_EDIT = `${USER_PERSON_BASE}/organisations/edition`;
export const PATH_USER_PERSON_CONTACT = `${USER_PERSON_BASE}/contact`;
export const PATH_USER_PERSON_CONTACT_EDIT = `${USER_PERSON_BASE}/contact/edition`;
export const PATH_USER_PERSON_PARTICIPATIONS = `${USER_PERSON_BASE}/missions`;
export const PATH_USER_PERSON_PENNYLANE = `${USER_PERSON_BASE}/pennylane`;
export const PATH_USER_PERSON_VERSIONS = `${USER_PERSON_BASE}/versions`;

//==========================================================================
// My account
//==========================================================================

const MY_ACCOUNT_BASE = '/mon-compte';
const MY_ACCOUNT_PERSON_BASE = `${MY_ACCOUNT_BASE}/personne`;

export const PATH_MY_ACCOUNT_USER_ACCOUNT = `${MY_ACCOUNT_BASE}/compte`;
export const PATH_MY_ACCOUNT_USER_DEFAULT = PATH_MY_ACCOUNT_USER_ACCOUNT;
export const PATH_MY_ACCOUNT_DEFAULT = PATH_MY_ACCOUNT_USER_DEFAULT;
export const PATH_MY_ACCOUNT_USER_AUTHORIZATIONS = `${MY_ACCOUNT_BASE}/autorisations`;
export const PATH_MY_ACCOUNT_USER_SETTINGS = `${MY_ACCOUNT_BASE}/reglages`;

export const PATH_MY_ACCOUNT_PERSON_GENERAL = `${MY_ACCOUNT_PERSON_BASE}/infos-generales`;
export const PATH_MY_ACCOUNT_PERSON_GENERAL_EDIT = `${MY_ACCOUNT_PERSON_BASE}/infos-generales/edition`;
export const PATH_MY_ACCOUNT_PERSON_DEFAULT = PATH_MY_ACCOUNT_PERSON_GENERAL;
export const PATH_MY_ACCOUNT_PERSON_ADDRESSES = `${MY_ACCOUNT_PERSON_BASE}/adresses`;
export const PATH_MY_ACCOUNT_PERSON_ADDRESSES_EDIT = `${MY_ACCOUNT_PERSON_BASE}/adresses/edition`;
export const PATH_MY_ACCOUNT_PERSON_ADDRESSES_EDIT_NEW = `${MY_ACCOUNT_PERSON_BASE}/adresses/edition/nouvelle`;
export const PATH_MY_ACCOUNT_PERSON_ADDRESSES_EDIT_MODIFY = `${MY_ACCOUNT_PERSON_BASE}/adresses/edition/:addressId/modifier`;
export const PATH_MY_ACCOUNT_PERSON_ADDRESSES_EDIT_DELETE = `${MY_ACCOUNT_PERSON_BASE}/adresses/edition/:addressId/supprimer`;
export const PATH_MY_ACCOUNT_PERSON_BANK = `${MY_ACCOUNT_PERSON_BASE}/banque`;
export const PATH_MY_ACCOUNT_PERSON_BANK_EDIT = `${MY_ACCOUNT_PERSON_BASE}/banque/edition`;
export const PATH_MY_ACCOUNT_PERSON_BILLING = `${MY_ACCOUNT_PERSON_BASE}/facturation`;
export const PATH_MY_ACCOUNT_PERSON_BILLING_EDIT = `${MY_ACCOUNT_PERSON_BASE}/facturation/edition`;
export const PATH_MY_ACCOUNT_PERSON_MEMBERSHIPS = `${MY_ACCOUNT_PERSON_BASE}/organisations`;
export const PATH_MY_ACCOUNT_PERSON_MEMBERSHIPS_EDIT = `${MY_ACCOUNT_PERSON_BASE}/organisations/edition`;
export const PATH_MY_ACCOUNT_PERSON_CONTACT = `${MY_ACCOUNT_PERSON_BASE}/contact`;
export const PATH_MY_ACCOUNT_PERSON_CONTACT_EDIT = `${MY_ACCOUNT_PERSON_BASE}/contact/edition`;
export const PATH_MY_ACCOUNT_PERSON_PARTICIPATIONS = `${MY_ACCOUNT_PERSON_BASE}/missions`;
export const PATH_MY_ACCOUNT_PERSON_PENNYLANE = `${MY_ACCOUNT_PERSON_BASE}/pennylane`;
export const PATH_MY_ACCOUNT_PERSON_VERSIONS = `${MY_ACCOUNT_PERSON_BASE}/versions`;
export const PATH_MY_ACCOUNT_PERSON_ADMIN = `${MY_ACCOUNT_PERSON_BASE}/administration`;
export const PATH_MY_ACCOUNT_PERSON_ADMIN_EDIT = `${MY_ACCOUNT_PERSON_BASE}/administration/edition`;

//==========================================================================
// Folders
//==========================================================================

export const PATH_FOLDERS_OPEN = '/dossiers/ouverts';
export const PATH_FOLDERS_DEFAULT = PATH_FOLDERS_OPEN;
export const PATH_FOLDERS_NOT_OPEN = '/dossiers/archives';
export const PATH_FOLDERS_NEW = '/dossiers/nouveau';

// Folder base path (used for nesting)
const FOLDER_BASE = '/dossiers/:folderId';

export const PATH_FOLDER_GENERAL = `${FOLDER_BASE}/infos-generales`;
export const PATH_FOLDER_DEFAULT = PATH_FOLDER_GENERAL;
export const PATH_FOLDER_GENERAL_EDIT = `${FOLDER_BASE}/infos-generales/edition`;
export const PATH_FOLDER_GENERAL_EDIT_CODE = `${FOLDER_BASE}/infos-generales/code/edition`;
export const PATH_FOLDER_GENERAL_EDIT_STATE = `${FOLDER_BASE}/infos-generales/statut/edition`;
export const PATH_FOLDER_ADDRESS = `${FOLDER_BASE}/adresse`;
export const PATH_FOLDER_ADDRESS_EDIT = `${FOLDER_BASE}/adresse/edition`;
export const PATH_FOLDER_INTERNAL_ACTORS = `${FOLDER_BASE}/acteurs-socna`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT = `${FOLDER_BASE}/acteurs-socna/edition`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT_DELETE = `${FOLDER_BASE}/acteurs-socna/edition/:actorId/supprimer`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT_FLUSH = `${FOLDER_BASE}/acteurs-socna/edition/heriter`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT_CUSTOMIZE = `${FOLDER_BASE}/acteurs-socna/edition/personnaliser`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT_MODIFY = `${FOLDER_BASE}/acteurs-socna/edition/:actorId/modifier`;
export const PATH_FOLDER_INTERNAL_ACTORS_EDIT_NEW = `${FOLDER_BASE}/acteurs-socna/edition/nouveau`;
export const PATH_FOLDER_EXTERNAL_ACTORS = `${FOLDER_BASE}/acteurs-externes`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT = `${FOLDER_BASE}/acteurs-externes/edition`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT_DELETE = `${FOLDER_BASE}/acteurs-externes/edition/:actorId/supprimer`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT_FLUSH = `${FOLDER_BASE}/acteurs-externes/edition/heriter`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT_CUSTOMIZE = `${FOLDER_BASE}/acteurs-externes/edition/personnaliser`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT_MODIFY = `${FOLDER_BASE}/acteurs-externes/edition/:actorId/modifier`;
export const PATH_FOLDER_EXTERNAL_ACTORS_EDIT_NEW = `${FOLDER_BASE}/acteurs-externes/edition/nouveau`;
export const PATH_FOLDER_ARCHIVE_INFO = `${FOLDER_BASE}/archivage`;
export const PATH_FOLDER_VERSIONS = `${FOLDER_BASE}/versions`;

export const PATH_FOLDER_MISSIONS = `${FOLDER_BASE}/missions`;
export const PATH_FOLDER_MISSIONS_NEW = `${FOLDER_BASE}/missions/nouvelle`;
export const PATH_FOLDER_COLLABORATIONS_NEW = `${FOLDER_BASE}/collaborations/nouvelle`;

export const PATH_FOLDER_BUSINESS_EVENTS = `${FOLDER_BASE}/evenements-metier`;
export const PATH_FOLDER_FILES_DEFAULT = `${FOLDER_BASE}/fichiers`;
export const PATH_FOLDER_FILES_DETAIL = `${FOLDER_BASE}/fichiers/:fileCategoryId/:mode/:fileId?`;

//==========================================================================
// Missions (nested under Folder)
//==========================================================================

// Mission base path (nested under folder): a collaboration (composite mission)
// is served under "collaborations", any other mission under "missions" (see
// MissionSpaceEnum).
const MISSION_BASE = `${FOLDER_BASE}/:missionSpace/:missionId`;

export const PATH_MISSION_GENERAL = `${MISSION_BASE}/infos-generales`;
export const PATH_MISSION_DEFAULT = PATH_MISSION_GENERAL;
export const PATH_MISSION_GENERAL_EDIT = `${MISSION_BASE}/infos-generales/edition`;
export const PATH_MISSION_GENERAL_EDIT_CODE = `${MISSION_BASE}/infos-generales/code/edition`;
export const PATH_MISSION_GENERAL_EDIT_COLLABORATION = `${MISSION_BASE}/infos-generales/collaboration/edition`;
export const PATH_MISSION_GENERAL_EDIT_STATE = `${MISSION_BASE}/infos-generales/statut/edition`;
export const PATH_MISSION_ADDRESS = `${MISSION_BASE}/adresse`;
export const PATH_MISSION_ADDRESS_EDIT = `${MISSION_BASE}/adresse/edition`;
export const PATH_MISSION_INTERNAL_ACTORS = `${MISSION_BASE}/acteurs-socna`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT = `${MISSION_BASE}/acteurs-socna/edition`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT_DELETE = `${MISSION_BASE}/acteurs-socna/edition/:actorId/supprimer`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT_FLUSH = `${MISSION_BASE}/acteurs-socna/edition/heriter`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT_CUSTOMIZE = `${MISSION_BASE}/acteurs-socna/edition/personnaliser`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT_MODIFY = `${MISSION_BASE}/acteurs-socna/edition/:actorId/modifier`;
export const PATH_MISSION_INTERNAL_ACTORS_EDIT_NEW = `${MISSION_BASE}/acteurs-socna/edition/nouveau`;
export const PATH_MISSION_EXTERNAL_ACTORS = `${MISSION_BASE}/acteurs-externes`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT = `${MISSION_BASE}/acteurs-externes/edition`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT_DELETE = `${MISSION_BASE}/acteurs-externes/edition/:actorId/supprimer`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT_FLUSH = `${MISSION_BASE}/acteurs-externes/edition/heriter`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT_CUSTOMIZE = `${MISSION_BASE}/acteurs-externes/edition/personnaliser`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT_MODIFY = `${MISSION_BASE}/acteurs-externes/edition/:actorId/modifier`;
export const PATH_MISSION_EXTERNAL_ACTORS_EDIT_NEW = `${MISSION_BASE}/acteurs-externes/edition/nouveau`;
export const PATH_MISSION_ARCHIVE_INFO = `${MISSION_BASE}/archivage`;
export const PATH_MISSION_VERSIONS = `${MISSION_BASE}/versions`;

const MISSION_QUOTATION_BASE = `${MISSION_BASE}/devis`;

export const PATH_MISSION_QUOTATION_INFO = `${MISSION_QUOTATION_BASE}/infos`;
export const PATH_MISSION_QUOTATION_INFO_EDIT = `${MISSION_QUOTATION_BASE}/infos/edition`;
export const PATH_MISSION_QUOTATION_INFO_EDIT_STATE = `${MISSION_QUOTATION_BASE}/infos/statut/edition`;
export const PATH_MISSION_QUOTATION_INIT = `${MISSION_QUOTATION_BASE}/initialiser`;
export const PATH_MISSION_QUOTATION_EDITOR = `${MISSION_QUOTATION_BASE}/editeur`;
export const PATH_MISSION_QUOTATION_DEFAULT = PATH_MISSION_QUOTATION_EDITOR;
export const PATH_MISSION_QUOTATION_SUMMARY = `${MISSION_QUOTATION_BASE}/table-des-matieres`;
export const PATH_MISSION_QUOTATION_PREVIEW = `${MISSION_QUOTATION_BASE}/apercu`;
export const PATH_MISSION_QUOTATION_GENERATION = `${MISSION_QUOTATION_BASE}/generation`;
export const PATH_MISSION_QUOTATION_SHARE = `${MISSION_QUOTATION_BASE}/partage`;
export const PATH_MISSION_QUOTATION_VERSIONS = `${MISSION_QUOTATION_BASE}/versions`;

const MISSION_SERVICE_USAGES_BASE = `${MISSION_BASE}/chiffrage`;

export const PATH_MISSION_SERVICE_USAGES = MISSION_SERVICE_USAGES_BASE;
export const PATH_MISSION_SERVICE_USAGES_DEFAULT = PATH_MISSION_SERVICE_USAGES;
export const PATH_MISSION_SERVICE_USAGES_SUB_MISSION = `${MISSION_SERVICE_USAGES_BASE}/sous-missions/:subMissionId`;
export const PATH_MISSION_SERVICE_USAGES_EDIT = `${MISSION_SERVICE_USAGES_BASE}/edition`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_SUB_MISSION = `${MISSION_SERVICE_USAGES_BASE}/edition/sous-missions/:subMissionId`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_DELETE = `${MISSION_SERVICE_USAGES_BASE}/edition/:serviceUsageId/supprimer`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ALL = `${MISSION_SERVICE_USAGES_BASE}/edition/heriter`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ONE = `${MISSION_SERVICE_USAGES_BASE}/edition/:serviceUsageId/heriter`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ALL = `${MISSION_SERVICE_USAGES_BASE}/edition/personnaliser`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ONE = `${MISSION_SERVICE_USAGES_BASE}/edition/:serviceUsageId/personnaliser`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_MODIFY = `${MISSION_SERVICE_USAGES_BASE}/edition/:serviceUsageId/modifier`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_NEW = `${MISSION_SERVICE_USAGES_BASE}/edition/nouvelle`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_NEW_IN_GROUP = `${MISSION_SERVICE_USAGES_BASE}/edition/groupes/:serviceUsagesGroupId/nouvelle`;
export const PATH_MISSION_SERVICE_USAGES_EDIT_REORDER = `${MISSION_SERVICE_USAGES_BASE}/edition/reordonner`;

export const PATH_MISSION_TOOLKITS = `${MISSION_BASE}/outils`;
export const PATH_MISSION_TOOLKITS_DEFAULT = PATH_MISSION_TOOLKITS;
export const PATH_MISSION_TOOLKIT = `${MISSION_BASE}/outils/:toolkitId`;
export const PATH_MISSION_TOOLKIT_EDIT = `${MISSION_BASE}/outils/:toolkitId/edition`;

export const PATH_MISSION_REPORTS = `${MISSION_BASE}/rapports`;
export const PATH_MISSION_REPORTS_INIT = `${PATH_MISSION_REPORTS}/initialiser`;

const MISSION_REPORT_BASE = `${PATH_MISSION_REPORTS}/:reportInfoId`;

export const PATH_MISSION_REPORT_INFO = `${MISSION_REPORT_BASE}/infos`;
export const PATH_MISSION_REPORT_INFO_EDIT = `${MISSION_REPORT_BASE}/infos/edition`;
export const PATH_MISSION_REPORT_INFO_EDIT_STATE = `${MISSION_REPORT_BASE}/infos/statut/edition`;
export const PATH_MISSION_REPORT_EDITOR = `${MISSION_REPORT_BASE}/editeur`;
export const PATH_MISSION_REPORT_DEFAULT = PATH_MISSION_REPORT_EDITOR;
export const PATH_MISSION_REPORT_SUMMARY = `${MISSION_REPORT_BASE}/table-des-matieres`;
export const PATH_MISSION_REPORT_PREVIEW = `${MISSION_REPORT_BASE}/apercu`;
export const PATH_MISSION_REPORT_GENERATION = `${MISSION_REPORT_BASE}/generation`;
export const PATH_MISSION_REPORT_SHARE = `${MISSION_REPORT_BASE}/partage`;
export const PATH_MISSION_REPORT_VERSIONS = `${MISSION_REPORT_BASE}/versions`;

export const PATH_MISSION_ACCOUNTING_INFO = `${MISSION_BASE}/comptabilite`;
export const PATH_MISSION_ACCOUNTING_INIT = `${MISSION_BASE}/comptabilite/initialiser`;
export const PATH_MISSION_ACCOUNTING_DEFAULT = PATH_MISSION_ACCOUNTING_INFO;

export const PATH_MISSION_BUSINESS_EVENTS = `${MISSION_BASE}/evenements-metier`;
export const PATH_MISSION_SUB_MISSIONS = `${MISSION_BASE}/sous-missions`;
export const PATH_COLLABORATION_MISSIONS_NEW = `${FOLDER_BASE}/collaborations/:missionId/sous-missions/nouvelle`;
export const PATH_MISSION_FILES_DEFAULT = `${MISSION_BASE}/fichiers`;
export const PATH_MISSION_FILES_DETAIL = `${MISSION_BASE}/fichiers/:fileCategoryId/:mode/:fileId?`;

//==========================================================================
// Business Events
//==========================================================================

const BUSINESS_EVENT_BASE = '/evenement-metier/:id';

export const PATH_BUSINESS_EVENT_GENERAL = `${BUSINESS_EVENT_BASE}/infos-generales`;
export const PATH_BUSINESS_EVENT_DEFAULT = PATH_BUSINESS_EVENT_GENERAL;

//==========================================================================
// Master Datas
//==========================================================================

// Costs
export const PATH_COSTS = '/couts';
export const PATH_COSTS_NEW = '/couts/nouveau';

const COST_BASE = '/cout/:id';

export const PATH_COST_GENERAL = `${COST_BASE}/infos-generales`;
export const PATH_COST_GENERAL_EDIT = `${COST_BASE}/infos-generales/edition`;
export const PATH_COST_DEFAULT = PATH_COST_GENERAL;
export const PATH_COST_ADMIN = `${COST_BASE}/administration`;
export const PATH_COST_ADMIN_EDIT = `${COST_BASE}/administration/edition`;
export const PATH_COST_VERSIONS = `${COST_BASE}/versions`;

// Materials
export const PATH_MATERIALS = '/materiels';
export const PATH_MATERIALS_NEW = '/materiels/nouveau';

const MATERIAL_BASE = '/materiel/:id';

export const PATH_MATERIAL_GENERAL = `${MATERIAL_BASE}/infos-generales`;
export const PATH_MATERIAL_GENERAL_EDIT = `${MATERIAL_BASE}/infos-generales/edition`;
export const PATH_MATERIAL_DEFAULT = PATH_MATERIAL_GENERAL;
export const PATH_MATERIAL_COSTS = `${MATERIAL_BASE}/couts`;
export const PATH_MATERIAL_COSTS_EDIT = `${MATERIAL_BASE}/couts/edition`;
export const PATH_MATERIAL_ADMIN = `${MATERIAL_BASE}/administration`;
export const PATH_MATERIAL_ADMIN_EDIT = `${MATERIAL_BASE}/administration/edition`;
export const PATH_MATERIAL_VERSIONS = `${MATERIAL_BASE}/versions`;

// Resolvable Services
export const PATH_RESOLVABLE_SERVICES = '/services';
export const PATH_RESOLVABLE_SERVICES_NEW = '/services/nouveau';

const RESOLVABLE_SERVICE_BASE = '/service/:id';

export const PATH_RESOLVABLE_SERVICE_GENERAL = `${RESOLVABLE_SERVICE_BASE}/infos-generales`;
export const PATH_RESOLVABLE_SERVICE_GENERAL_EDIT = `${RESOLVABLE_SERVICE_BASE}/infos-generales/edition`;
export const PATH_RESOLVABLE_SERVICE_QUOTATION_INFO = `${RESOLVABLE_SERVICE_BASE}/info-devis`;
export const PATH_RESOLVABLE_SERVICE_QUOTATION_INFO_EDIT = `${RESOLVABLE_SERVICE_BASE}/info-devis/edition`;
export const PATH_RESOLVABLE_SERVICE_DEFAULT = PATH_RESOLVABLE_SERVICE_GENERAL;
export const PATH_RESOLVABLE_SERVICE_MATERIALS = `${RESOLVABLE_SERVICE_BASE}/materiels`;
export const PATH_RESOLVABLE_SERVICE_MATERIALS_EDIT = `${RESOLVABLE_SERVICE_BASE}/materiels/edition`;
export const PATH_RESOLVABLE_SERVICE_COSTS = `${RESOLVABLE_SERVICE_BASE}/couts`;
export const PATH_RESOLVABLE_SERVICE_COSTS_EDIT = `${RESOLVABLE_SERVICE_BASE}/couts/edition`;
export const PATH_RESOLVABLE_SERVICE_ADMIN = `${RESOLVABLE_SERVICE_BASE}/administration`;
export const PATH_RESOLVABLE_SERVICE_ADMIN_EDIT = `${RESOLVABLE_SERVICE_BASE}/administration/edition`;
export const PATH_RESOLVABLE_SERVICE_VERSIONS = `${RESOLVABLE_SERVICE_BASE}/versions`;

// Resolvable Mission Types
export const PATH_RESOLVABLE_MISSION_TYPES = '/types-mission';
export const PATH_RESOLVABLE_MISSION_TYPES_NEW = '/types-mission/nouveau';

const RESOLVABLE_MISSION_TYPE_BASE = '/type-mission/:id';

export const PATH_RESOLVABLE_MISSION_TYPE_GENERAL = `${RESOLVABLE_MISSION_TYPE_BASE}/infos-generales`;
export const PATH_RESOLVABLE_MISSION_TYPE_GENERAL_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/infos-generales/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_DEFAULT =
  PATH_RESOLVABLE_MISSION_TYPE_GENERAL;
export const PATH_RESOLVABLE_MISSION_TYPE_TEMPLATES = `${RESOLVABLE_MISSION_TYPE_BASE}/modeles`;
export const PATH_RESOLVABLE_MISSION_TYPE_TEMPLATES_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/modeles/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_QUOTATION_HEADER = `${RESOLVABLE_MISSION_TYPE_BASE}/entete-devis`;
export const PATH_RESOLVABLE_MISSION_TYPE_QUOTATION_HEADER_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/entete-devis/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_FILES = `${RESOLVABLE_MISSION_TYPE_BASE}/fichiers`;
export const PATH_RESOLVABLE_MISSION_TYPE_FILES_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/fichiers/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_TOOLKITS = `${RESOLVABLE_MISSION_TYPE_BASE}/outils`;
export const PATH_RESOLVABLE_MISSION_TYPE_TOOLKITS_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/outils/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT_DELETE = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition/:serviceUsageId/supprimer`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT_MODIFY = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition/:serviceUsageId/modifier`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT_NEW = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition/nouvelle`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT_NEW_IN_GROUP = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition/groupes/:serviceUsagesGroupId/nouvelle`;
export const PATH_RESOLVABLE_MISSION_TYPE_SERVICE_USAGES_EDIT_REORDER = `${RESOLVABLE_MISSION_TYPE_BASE}/prestations/edition/reordonner`;
export const PATH_RESOLVABLE_MISSION_TYPE_ADMIN = `${RESOLVABLE_MISSION_TYPE_BASE}/administration`;
export const PATH_RESOLVABLE_MISSION_TYPE_ADMIN_EDIT = `${RESOLVABLE_MISSION_TYPE_BASE}/administration/edition`;
export const PATH_RESOLVABLE_MISSION_TYPE_VERSIONS = `${RESOLVABLE_MISSION_TYPE_BASE}/versions`;

//==========================================================================
// Document Edition
//==========================================================================

export const PATH_DOCUMENT_TEMPLATES = '/modeles/documents';
export const PATH_DOCUMENT_AND_SECTION_TEMPLATES_DEFAULT =
  PATH_DOCUMENT_TEMPLATES;

const DOCUMENT_TEMPLATES_NEW_BASE = '/modeles/documents/nouveau';

export const PATH_DOCUMENT_TEMPLATES_NEW_INFO = `${DOCUMENT_TEMPLATES_NEW_BASE}/infos`;
export const PATH_DOCUMENT_TEMPLATES_NEW_INFO_EDIT = `${DOCUMENT_TEMPLATES_NEW_BASE}/infos/edition`;
export const PATH_DOCUMENT_TEMPLATES_NEW_DEFAULT =
  PATH_DOCUMENT_TEMPLATES_NEW_INFO_EDIT;
export const PATH_DOCUMENT_TEMPLATES_NEW_EDITOR = `${DOCUMENT_TEMPLATES_NEW_BASE}/editeur`;
export const PATH_DOCUMENT_TEMPLATES_NEW_SUMMARY = `${DOCUMENT_TEMPLATES_NEW_BASE}/table-des-matieres`;

const DOCUMENT_TEMPLATE_BASE = '/modeles/document/:id';

export const PATH_DOCUMENT_TEMPLATE_INFO = `${DOCUMENT_TEMPLATE_BASE}/infos`;
export const PATH_DOCUMENT_TEMPLATE_INFO_EDIT = `${DOCUMENT_TEMPLATE_BASE}/infos/edition`;
export const PATH_DOCUMENT_TEMPLATE_EDITOR = `${DOCUMENT_TEMPLATE_BASE}/editeur`;
export const PATH_DOCUMENT_TEMPLATE_DEFAULT = PATH_DOCUMENT_TEMPLATE_EDITOR;
export const PATH_DOCUMENT_TEMPLATE_SUMMARY = `${DOCUMENT_TEMPLATE_BASE}/table-des-matieres`;
export const PATH_DOCUMENT_TEMPLATE_PREVIEW = `${DOCUMENT_TEMPLATE_BASE}/apercu`;
export const PATH_DOCUMENT_TEMPLATE_GENERATION = `${DOCUMENT_TEMPLATE_BASE}/generation`;
export const PATH_DOCUMENT_TEMPLATE_VERSIONS = `${DOCUMENT_TEMPLATE_BASE}/versions`;
export const PATH_DOCUMENT_TEMPLATE_ADMIN = `${DOCUMENT_TEMPLATE_BASE}/administration`;
export const PATH_DOCUMENT_TEMPLATE_ADMIN_EDIT = `${DOCUMENT_TEMPLATE_BASE}/administration/edition`;

export const PATH_SECTION_TEMPLATES = '/modeles/sections';

const SECTION_TEMPLATES_NEW_BASE = '/modeles/sections/nouveau';

export const PATH_SECTION_TEMPLATES_NEW_INFO = `${SECTION_TEMPLATES_NEW_BASE}/infos`;
export const PATH_SECTION_TEMPLATES_NEW_INFO_EDIT = `${SECTION_TEMPLATES_NEW_BASE}/infos/edition`;
export const PATH_SECTION_TEMPLATES_NEW_DEFAULT =
  PATH_SECTION_TEMPLATES_NEW_INFO_EDIT;
export const PATH_SECTION_TEMPLATES_NEW_EDITOR = `${SECTION_TEMPLATES_NEW_BASE}/editeur`;
export const PATH_SECTION_TEMPLATES_NEW_SUMMARY = `${SECTION_TEMPLATES_NEW_BASE}/table-des-matieres`;

const SECTION_TEMPLATE_BASE = '/modeles/section/:id';

export const PATH_SECTION_TEMPLATE_INFO = `${SECTION_TEMPLATE_BASE}/infos`;
export const PATH_SECTION_TEMPLATE_INFO_EDIT = `${SECTION_TEMPLATE_BASE}/infos/edition`;
export const PATH_SECTION_TEMPLATE_EDITOR = `${SECTION_TEMPLATE_BASE}/editeur`;
export const PATH_SECTION_TEMPLATE_DEFAULT = PATH_SECTION_TEMPLATE_EDITOR;
export const PATH_SECTION_TEMPLATE_SUMMARY = `${SECTION_TEMPLATE_BASE}/table-des-matieres`;
export const PATH_SECTION_TEMPLATE_PREVIEW = `${SECTION_TEMPLATE_BASE}/apercu`;
export const PATH_SECTION_TEMPLATE_VERSIONS = `${SECTION_TEMPLATE_BASE}/versions`;
export const PATH_SECTION_TEMPLATE_ADMIN = `${SECTION_TEMPLATE_BASE}/administration`;
export const PATH_SECTION_TEMPLATE_ADMIN_EDIT = `${SECTION_TEMPLATE_BASE}/administration/edition`;

//==========================================================================
// Printer
//==========================================================================

export {
  PATH_DOCUMENT_TEMPLATES_NEW_PRINTER,
  PATH_DOCUMENT_TEMPLATE_PRINTER,
  PATH_SECTION_TEMPLATES_NEW_PRINTER,
  PATH_SECTION_TEMPLATE_PRINTER,
  PATH_MISSION_REPORT_PRINTER,
  PATH_MISSION_QUOTATION_PRINTER,
} from '@e-socna/printer-contract';
